/* eslint-disable space-before-function-paren */
// 存放状态
const state = {
  // 是否密码登录
  isPasswordLogin: true,
  // 注册还是登录
  isLogin: true,
  isReset: true,
  isQrCode: true,
  // 判断用户是非已经登录状态
  isLoginType: false,
  ishidefun: false
}

// 异步操作
const actions = {
  set_isPassLogin(context, option) {
    context.commit('set_isPassLogin', option)
  },
  set_isLogin(context, option) {
    context.commit('set_isLogin', option)
  },
  set_isReset(context, option) {
    context.commit('set_isReset', option)
  },
  set_isQrCode(context, option) {
    context.commit('set_isQrCode', option)
  },
  set_isLoginType(context, option) {
    context.commit('set_isLoginType', option)
  },
  set_ishidefun(context, option) {
    context.commit('set_ishidefun', option)
  }
}

// 加工state成员给外界
const getters = {
  getLoginType(state) {
    return state.isLoginType
  }
}

// state成员操作
const mutations = {
  set_isPassLogin(state, options) {
    state.isPasswordLogin = options
  },
  set_isLogin(state, options) {
    state.isLogin = options
  },
  set_isReset(state, options) {
    state.isReset = options
  },
  set_isQrCode(state, options) {
    state.isQrCode = options
  },
  set_isLoginType(state, options) {
    state.isLoginType = options
  },
  set_ishidefun(state, options) {
    state.ishidefun = options
  }
}

// 导出该模块
export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js